import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Challenge, MonthlyChallengeContent } from '../../services/models/challenges.model';

@Component({
  selector: 'app-challenges-monthly-card',
  templateUrl: './challenges-monthly-card.component.html',
  styleUrls: ['./challenges-monthly-card.component.scss']
})
export class ChallengesMonthlyCardComponent {
  @Input() challenge: Challenge<MonthlyChallengeContent>;
  @Output() createChallenge = new EventEmitter<void>();
  @Output() updateChallenge = new EventEmitter<void>();
  @Output() deleteChallenge = new EventEmitter<void>();

  handleCreateButtonClick() {
    this.createChallenge.emit();
  }

  handleDelete() {
    this.deleteChallenge.emit();
  }

  handleUpdate() {
    this.updateChallenge.emit();
  }
}
